import React from 'react';
import parse from 'html-react-parser';
import {
	Col,
	Modal as ServaModal,
	Row,
} from '@servahealth/serva-ui-kit';
import DebugQuery from '../../../Interfaces/Reports/DebugQuery';

interface ReportItemNoDataProps {
	debugOnly?: boolean;
	debugQuery?: DebugQuery;
	debugQueryVisible?: boolean;
	hasFilters: boolean;
	queryLabel?: string;
	showDebug?: boolean;
	onCloseDebug?: () => void;
}

const ReportItemNoData = ({
	debugOnly = false,
	debugQuery,
	debugQueryVisible = false,
	hasFilters,
	queryLabel = 'DataSet Query',
	showDebug = false,
	onCloseDebug,
}: ReportItemNoDataProps) => {
	const message = hasFilters
		? 'No report data is available for the selected filters.'
		: 'No report data is available for this report item.';

	return (
		<>
			{!debugOnly && (
				<div
					style={{
						minHeight: '120px',
						height: '100%',
						width: '100%',
						boxSizing: 'border-box',
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
						position: 'relative',
						textAlign: 'center',
						backgroundColor: '#F5F7FA',
						border: '1px solid #D9E2EF',
						color: '#1F3A5F',
						padding: '16px 40px',
					}}
				>
					<span style={{ fontWeight: 600 }}>
						{message}
					</span>
				</div>
			)}
			{showDebug && (
				<ServaModal
					hideButtons={true}
					open={debugQueryVisible}
					styles={{body: {height: '65vh', overflowY: 'auto'}}}
					title={<b><u>Administrative Debug Information</u></b>}
					width={'800px'}
					onCancel={onCloseDebug}
				>
					<Row>
						<Col span={8}>
							<label><b><i>Report ID:</i></b></label>
						</Col>
						<Col span={16}>
							<label><b><i>Report Name:</i></b></label>
						</Col>
					</Row>
					<Row>
						<Col span={1}>
						</Col>
						<Col span={7}>
							<label>{debugQuery?.queryReportId}</label>
						</Col>
						<Col span={1}>
						</Col>
						<Col span={15}>
							<label>{debugQuery?.queryReportName}</label>
						</Col>
					</Row>
					<Row>
						<Col span={8}>
							<label><b><i>Report Page ID:</i></b></label>
						</Col>
						<Col span={16}>
							<label><b><i>Report Item ID:</i></b></label>
						</Col>
					</Row>
					<Row>
						<Col span={1}>
						</Col>
						<Col span={7}>
							<label>{debugQuery?.queryReportPageId}</label>
						</Col>
						<Col span={1}>
						</Col>
						<Col span={15}>
							<label>{debugQuery?.queryReportItemId}</label>
						</Col>
					</Row>
					<Row>
						<Col span={8}>
							<label><b><i>DataSet ID:</i></b></label>
						</Col>
						<Col span={16}>
							<label><b><i>Chart ID:</i></b></label>
						</Col>
					</Row>
					<Row>
						<Col span={1}>
						</Col>
						<Col span={7}>
							<label>{debugQuery?.queryDataSetId === 0 ? 'N/A' : debugQuery?.queryDataSetId}</label>
						</Col>
						<Col span={1}>
						</Col>
						<Col span={15}>
							<label>{debugQuery?.queryChartId === 0 ? 'N/A' : debugQuery?.queryChartId}</label>
						</Col>
					</Row>
					<Row>
						<Col span={8}>
							<label><b><i>Filters Applied:</i></b></label>
						</Col>
					</Row>
					<Row>
						<Col span={1}>
						</Col>
						<Col span={7}>
							<label>{hasFilters ? 'Yes' : 'No'}</label>
						</Col>
					</Row>
					<Row>
						<Col span={24}>
							<label><b><i>{queryLabel}:</i></b></label>
						</Col>
					</Row>
					<Row>
						<Col span={24}>
							<pre>{parse(debugQuery?.queryString ?? '')}</pre>
						</Col>
					</Row>
				</ServaModal>
			)}
		</>
	);
};

export default ReportItemNoData;
